import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from '@/i18n/navigation';
import { ProductType } from '@/types/product';
import LazyImage from '@/components/partials/lazy-image';
import { getResizedPictureUrl } from '@/lib/utils';
import { NoImagePlaceholder } from '@/components/partials';
type PropsType = {
  product: ProductExtendedType;
};
type ProductExtendedType = ProductType & {
  title: string;
  detailHref: string;
};
const RelatedProductItem = t0 => {
  const $ = _c(24);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product.oemNumbers) {
    t1 = new Set(product.oemNumbers?.map(_temp).filter(Boolean) ?? []);
    $[0] = product.oemNumbers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [...t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const oemList = t2;
  const oemText = oemList.join(", ");
  let t3;
  if ($[4] !== product.code || $[5] !== product.mainPicture || $[6] !== product.title) {
    t3 = <div className="bg-background flex h-16 w-16 shrink-0 items-center justify-center rounded-md">{product.mainPicture ? <LazyImage src={getResizedPictureUrl(product.mainPicture.path, 120, 60)} alt={`${product.code} / ${product.title}`} width={120} height={60} className="h-full w-full object-contain p-1 transition-all duration-300" /> : <div className="flex h-full w-full items-center justify-center"><NoImagePlaceholder iconSize={6} /></div>}</div>;
    $[4] = product.code;
    $[5] = product.mainPicture;
    $[6] = product.title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== product.title) {
    t4 = <p className="group-hover:text-brand-darken w-full truncate font-medium transition-all duration-300">{product.title}</p>;
    $[8] = product.title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== product.code) {
    t5 = <p className="text-muted-foreground text-sm transition-all duration-300 group-hover:text-gray-600">{product.code}</p>;
    $[10] = product.code;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== oemList.length || $[13] !== oemText) {
    t6 = oemList.length > 0 && <span className="text-muted-foreground line-clamp-1 w-full text-xs" title={oemText}>{oemText}</span>;
    $[12] = oemList.length;
    $[13] = oemText;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className="flex w-full min-w-0 flex-col items-start justify-start">{t4}{t5}{t6}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== product.detailHref || $[20] !== product.id || $[21] !== t3 || $[22] !== t7) {
    t8 = <Link href={product.detailHref} key={product.id} className="bg-muted/30 hover:bg-muted hover:border-brand/50 group flex items-start gap-3 rounded-lg border p-3 transition-all duration-300">{t3}{t7}</Link>;
    $[19] = product.detailHref;
    $[20] = product.id;
    $[21] = t3;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default RelatedProductItem;
function _temp(oem) {
  return oem.oem;
}